import React from "react";
import images from "../../../Utils/importImages";

function NoTravellers() {
  return (
    <div className="no-traveller-wrapper">
        <img src={images["traveller-svg-ico.svg"]} alt="" />
        <div className="no-traveller-info">
          <h3 className="proxima_semibold">0 Traveller Added</h3>
          <span>Add Travellers to see here</span>
        </div>
      </div>
  );
}

export default NoTravellers;
